import React, { Component } from 'react'
import PropTypes from 'prop-types'

class JsonObject extends Component {
  state = { isExpanded: false }

  expand = () => {
    this.setState({ isExpanded: true })
  }

  unexpand = () => {
    this.setState({ isExpanded: false })
  }

  render() {
    if (this.state.isExpanded === false) {
      return <span onClick={this.expand}>{this.props.index === 0 ? '' : ' — '}Object</span>
    }

    return (
      <pre className={this.props.className}>
        <p onClick={this.unexpand}>Object</p>
        {JSON.stringify(this.props.message, null, 2)}
      </pre>
    )
  }
}

JsonObject.propTypes = {
  message: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
}

export default JsonObject
